import { ErrorMessagePropsModel } from './ErrorMessage.model';
import styles from './ErrorMessage.module.scss';

export function ErrorMessage(props: ErrorMessagePropsModel) {
  return <p className={styles.rfErrorMessage}> {props.message} </p>;
}
